<script setup lang="ts">
    import { computed } from 'vue';
    import { useRoute } from 'vue-router';

    const props = defineProps<{
        ActivePage?: string;
        propStrategyId?: string;
    }>();

    const route = useRoute();

    const workspaceId = computed(() => Number(route.params?.workspaceId ?? 0));
    const strategyId = computed(() => route.params?.strategyId ?? props.propStrategyId);
</script>

<template>
    <nav class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark" style="margin-bottom: 0;" data-testid="corporate-nav">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navBar" aria-expanded="false" aria-label="Toggle navigation" data-testid="corporate-nav-toggle">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navBar">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="navbar-brand" v-sanitizedHref="`/#/strategy/portfolios/${workspaceId}/${strategyId}`" data-testid="corporate-nav-portfolios">
                        Portfolios
                    </a>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" data-testid="corporate-nav-projects">
                        Projects
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/proposals/${workspaceId}/${strategyId}`" data-testid="corporate-nav-projects-proposals">Proposals</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/scheduled/${workspaceId}/${strategyId}`" data-testid="corporate-nav-projects-scheduled">Scheduled</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/started/${workspaceId}/${strategyId}`" data-testid="corporate-nav-projects-started">Started</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/finished/${workspaceId}/${strategyId}`" data-testid="corporate-nav-projects-finished">Finished</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/projects/all/${workspaceId}/${strategyId}`" data-testid="corporate-nav-projects-all">All</a>
                    </div>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" data-testid="corporate-nav-manage">
                        Manage
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/settings/${workspaceId}/${strategyId}`" data-testid="corporate-nav-manage-settings">Settings</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/attributes/${workspaceId}/${strategyId}`" data-testid="corporate-nav-manage-attributes">Attributes</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/resources/${workspaceId}/${strategyId}`" data-testid="corporate-nav-manage-resources">Resources</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/revenues/${workspaceId}/${strategyId}`" data-testid="corporate-nav-manage-revenues">Revenues</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/costs/${workspaceId}/${strategyId}`" data-testid="corporate-nav-manage-costs">Costs</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/capex/${workspaceId}/${strategyId}`" data-testid="corporate-nav-manage-capex">CAPEX</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/pnls/${workspaceId}/${strategyId}`" data-testid="corporate-nav-manage-pnls">P&Ls</a>
                    </div>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" data-testid="corporate-nav-business-case">
                        Business case
                    </a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/business-case-templates/${workspaceId}/${strategyId}`" data-testid="corporate-nav-business-case-templates">Templates</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/enterprise/metrics/${workspaceId}/${strategyId}`" data-testid="corporate-nav-business-case-metrics">Metrics</a>
                        <!--<a class="dropdown-item" v-sanitizedHref="`/#/enterprise/project-phases/${workspaceId}/${strategyId}`" data-testid="corporate-nav-business-case-project-phases">Phases</a>-->
                    </div>
                </li>

                <li class="nav-item">
                    <a class="nav-link" v-sanitizedHref="`/#/enterprise/planning/${workspaceId}/${strategyId}`" data-testid="corporate-nav-planning">Planning</a>
                </li>

                <!--<li class="nav-item">
        <a class="nav-link" v-sanitizedHref="``">Stakeholders</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" v-sanitizedHref="``">Risks</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" v-sanitizedHref="``">Decisions</a>
    </li>-->
            </ul>

            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" data-testid="corporate-nav-account">
                        Account
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" v-sanitizedHref="`/#/projects/${workspaceId}`" data-testid="corporate-nav-account-workspace">Back to workspace</a>
                        <a class="dropdown-item" href="/#/organizations/users/dashboard" data-testid="corporate-nav-account-dashboard">My dashboard</a>
                        <a class="dropdown-item" v-sanitizedHref="`/#/organizations/users/account`" data-testid="corporate-nav-account-manage">Manage your account</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" v-sanitizedHref="`/organizations/sessions/close`" data-testid="corporate-nav-account-sign-out">Sign out</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<style scoped>
    a.nav-link {
        color: #bbb !important;
    }

        a.nav-link:hover {
            color: #fff !important;
        }

    .navbar {
        -webkit-box-shadow: 0 2px 6px 0 #999;
        -moz-box-shadow: 0 2px 6px 0 #999;
        box-shadow: 0 2px 6px 0 #999;
    }

</style>